import { z } from 'zod';

/** Taring is the only command; the sensor is otherwise read-only. */
export const RobotiqTSF85DirectCommands = z.literal('tare');

export type RobotiqTSF85DirectCommands = z.infer<
  typeof RobotiqTSF85DirectCommands
>;

/**
 * Carries `equipmentId` because a robot can hold more than one tactile row and
 * the kind alone would not say which. `Equipment.executeCommand` targets on it
 * directly, so this reaches the right device on live and simulated robots
 * without the caller resolving the device itself.
 */
export const RobotiqTSF85Command = z.object({
  kind: z.literal('RobotiqTSF85Command'),
  equipmentId: z.string(),
  command: RobotiqTSF85DirectCommands,
});

export type RobotiqTSF85Command = z.infer<typeof RobotiqTSF85Command>;
